const navVertical = () => {
  if (document.querySelectorAll(".navigation").length < 1) {
    return;
  }

  const menuItems = document.querySelectorAll(".menu-item-has-children");
  menuItems.forEach((item) => {
    const clone = item.cloneNode(true);
    item.parentNode.replaceChild(clone, item);
  });

  document.querySelectorAll(".menu-item-has-children").forEach((item) => {
    item.addEventListener("click", (event) => {
      event.stopPropagation();
      
      const submenu = item.querySelector('.sub-menu');
      if (!submenu) return;

      // if menu closed
      if (!item.classList.contains('opened')) {
        // remove transition
        submenu.style.transition = 'none';
        // remove height:0
        submenu.style.height = 'auto';
        // save height
        const height = submenu.scrollHeight;
        // restore height:0
        submenu.style.height = '0';
        // restore transition
        submenu.style.removeProperty('transition');
        
        // force reflow
        submenu.offsetHeight;
        
        // set target height
        submenu.style.height = `${height}px`;
        item.classList.add('opened');
      } else {
        // set height to current height
        const height = submenu.scrollHeight;
        submenu.style.height = `${height}px`;
        
        // force reflow
        submenu.offsetHeight;
        
        // animate to 0
        submenu.style.height = '0';
        item.classList.remove('opened');
      }
    });

    // clear inline styles after animation
    const submenu = item.querySelector('.sub-menu');
    if (submenu) {
      submenu.addEventListener('transitionend', () => {
        if (item.classList.contains('opened')) {
          submenu.style.height = 'auto';
        } else {
          // clear style when closed
          submenu.style.removeProperty('height');
        }
      });
    }
  });

  document.querySelectorAll(".hamburger").forEach((element) => {
    element.addEventListener("click", (event) => {
      element.classList.toggle("is-active");
    });
  });
};

export default navVertical;
